import type { UseMutationResult } from "@tanstack/react-query"

import {
  ConcertDocumentValidationError,
  concertDocumentUploadBody,
} from "./concert-document-upload"
import { useSolarConcertStatusCommand } from "./solar-concert-application-cache"
import type { SolarConcertApplicationStatusDto } from "../dto/solar-concert.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/** Upload or replace one Concert stipulation document for a Solar Proposal. */
export default function useUploadSolarConcertDocument(): UseMutationResult<
  SolarConcertApplicationStatusDto,
  unknown,
  {
    proposalId: string
    stipulationId: string
    requirementId: string
    file: File
  }
> {
  return useSolarConcertStatusCommand(
    async ({ proposalId, stipulationId, requirementId, file }) =>
      solarProposalService.uploadConcertDocument(
        proposalId,
        stipulationId,
        await concertDocumentUploadBody(file, requirementId),
      ),
    { isAnswer: (error) => error instanceof ConcertDocumentValidationError },
  )
}
